export default "__VITE_ASSET__2f09762e__"